// extracted by mini-css-extract-plugin
export default {"wrapper":"CalendarsPage_wrapper__hUOtz","datePicker":"CalendarsPage_datePicker__DQesk"};